var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',_vm._b({attrs:{"no-fade":""},on:{"input":_setup.setActiveTab},model:{value:(_setup.activeTabIndex),callback:function ($$v) {_setup.activeTabIndex=$$v},expression:"activeTabIndex"}},'b-tabs',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }